import { gql } from '@apollo/client';

// fragment
import { HOMEWORK_FRAG } from '../../fragments';

export const GET_HOMEWORK_DETAIL_LIST = gql`
  query SkWeb_HomeworkDetailList(
    $userId: ID
    $status: HomeworkStatusList
    $titleId: ID
    $booksetIds: [ID]
    $page: Int
    $pageSize: Int
  ) {
    homeworkDetailList(
      userId: $userId
      status: $status
      titleId: $titleId
      booksetIds: $booksetIds
      page: $page
      pageSize: $pageSize
    ) {
      data {
        ... on Homework {
          ...HomeworkFrag
        }
      }
      totalCount
    }
  }
  ${HOMEWORK_FRAG}
`;
